import axios from "axios";
import type { AxiosInstance } from "axios";
import { useAuthStore } from "~/stores/auth";

const axiosInstance: AxiosInstance = axios.create();

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();

  // Set the baseURL after creating the instance
  axiosInstance.defaults.baseURL = runtimeConfig.public.baseUrl;

  // Request interceptor for adding Authorization header
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = useAuthStore().token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor for handling errors
  axiosInstance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (error.response && error.response.status === 401) {
        console.error("Session Expired");
        useAuthStore().clearToken();
        useRouter().push("/");
        return;
      }
      if (error.response && error.response.status === 402) {
        return;
      }
      console.error(error.response?.data?.message || "An error occurred");
      return Promise.reject(error);
    }
  );

  // Provide the axios instance to the Nuxt app
  return {
    provide: { axios: axiosInstance },
  };
});

// Export the instance to make it importable in other files
export { axiosInstance };